"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siLocalHostBaseUrl = exports.siIntBaseUrl = exports.siProdBaseUrl = void 0;
exports.siProdBaseUrl = "https://api.supplierintegrations.cimpress.io";
exports.siIntBaseUrl = "https://int-api.supplierintegrations.cimpress.io";
exports.siLocalHostBaseUrl = "http://localhost:8080";
